export default "__VITE_ASSET__B3sy6yMe__"